import React, { PureComponent } from 'react'
import { Spin, Row, Col, Input, Button, Table, Modal, Form, message, Layout, InputNumber, Radio, DatePicker, Icon } from 'antd'
import { discountList, discountCreate, discountDetail } from '_src/api/api'
import { connect } from 'react-redux'
import moment from 'moment'

import './style/discount.less'

const { TextArea } = Input
const { RangePicker } = DatePicker
const { Search } = Input
const ColProps = {
  xs: 24,
  sm: 12,
  style: {
    marginBottom: 16,
  },
}

class Discount extends PureComponent {
  constructor () {
    super()
    this.state = {
      isLoading: false,

      modelVisible: false,
      lookModelVisible: false,
      submitting: false,
      
      params: {
        pageNum: 0,
        pageSize: 10,
      },

      pageData: {
        total: 0, 
        current: 1, 
      },

      list: [],

      columns: [
        {
          title: <span>编号</span>,
          align: 'center',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: <span>优惠劵名称</span>,
          dataIndex: 'name',
        },
        {
          title: <span>优惠劵类型</span>,
          render: item => <div>{item.type === 0 ? '满减券' : '折扣券'}</div>,
        },
        {
          title: <span>使用门槛</span>,
          render: item => <div>{item.useType === 1 ? (item.useTypeVal / 100).toFixed(2) : '无门槛'}</div>,
        },
        {
          title: <span>面值</span>,
          render: item => <div>{item.type === 1 ? item.disCount*10 + '折' : (item.disCount / 100).toFixed(2) + '元'}</div>,
        },
        {
          title: <span>有效期</span>,
          render: item => <div>{item.timeType === 0 ? `领取后${item.days}天有效` : `${item.startAt} 至 ${item.endAt}`}</div>,
        },
        {
          title: <span>状态</span>,
          render: item => <div>{item.timeType === 0 || (item.timeType === 1 && item.endAt > item.startAt) ? <div className="flex-h-a" style={{color: '#40a9ff'}}><Icon type="check-circle" theme="twoTone" style={{fontSize: 20, marginRight: 10}} /> 使用中</div> : '已过期'}</div>,
        },
        {
          title: <span>备注</span>,
          dataIndex: 'desc',
        },
        {
          title: <span>操作</span>,
          align: 'center',
          render: item => <div>
            <Button icon="eye" id={item.id} onClick={() => { this.lookDetail(item.id) }} style={{marginRight: '10px'}}>详情</Button>
          </div>,
        },
      ]
    }
  }

  componentDidMount () {
    const {params} = this.state
    this.loadList(params)
  }

  loadList (params) {
    this.setState({isLoading: true})
    discountList(params)
      .then(res => {
        const list = res.data.content
        list.forEach(item => {
          item.startAt = moment(item.startAt).format('YYYY-MM-DD')
          const endAt = new Date(item.endAt)
          endAt.setDate(endAt.getDate() - 1)
          item.endAt = moment(endAt).format('YYYY-MM-DD')
        })
        this.setState({
          list,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }

  // 分页
  onPageChange = (e) => {
    const {params} = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }

  // 优惠券搜索
  onSearch = (e) => {
    const {params} = this.state
    params.pageNum = 0
    if (e) {
      params.name = e
    } else {
      delete params.name
    }
    this.loadList(params)
  }

  // 创建优惠券弹窗
  create = (e) => {
    this.setState({createModelVisible: true})
  }
  // 关闭创建
  handleCancel = (e) => {
    this.setState({
      createModelVisible: false,
      lookModelVisible: false,
    })
  }
  // 提交创建优惠券
  handleSubmit = (e) => {
    e.preventDefault()
    if (this.state.submitting) return
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ submitting: true })
        const hide = message.loading('保存中...', 0)
        const finishSubmit = () => {
          hide()
          this.setState({ submitting: false })
        }
        let {type, timeType, days, useType, useTypeVal, timerArr} = this.state
        values.type = type
        values.timeType = timeType
        values.platformType = 1
        values.useType = Number(useType)
        const suerInfo = localStorage.getItem('access_info')
        if (suerInfo) {
          values.platformVal = [JSON.parse(suerInfo).id]
        }

        // 时间类型选择用户领取后计时
        if (values.timeType === 0) {
          if (days) {
            values.days = days
          } else {
            message.error('请输入优惠券有效时间')
            return
          }
        // 时间区间
        } else if (values.timeType === 1) {
          if (timerArr && timerArr.length) {
            values.startAt = moment(timerArr[0]).format('YYYY-MM-DD 00:00:00')
            const endAt = new Date(moment(timerArr[1]))
            endAt.setDate(endAt.getDate() + 1)
            values.endAt = moment(endAt).format('YYYY-MM-DD 00:00:00')
          } else {
            message.error('请选择优惠券有效时间')
          }
        }

        // 使用门槛
        if (values.useType === 1) {
          if (useTypeVal) {
            values.useTypeVal = Number(useTypeVal) * 100
          } else {
            message.error('请输入使用门槛')
          }
        }

        // 类型为满减
        if (values.type === 0) {
          values.disCount = Number(values.amount) * 100
        // 类型为折扣
        } else if (values.type === 1) {
          values.disCount = Number(values.disCount)/10
        }

        discountCreate(values).then(res => {
          finishSubmit()
          message.success('保存成功', 1.5, ()=>{
            const {pageSize} = this.state.params
            const params = {
              pageNum: 0,
              pageSize,
            }
            this.setState({
              createModelVisible: false,
              isLoading: true,
              params,
            })
            this.loadList(params)
          })
        }).catch(() => {
          finishSubmit()
        })
      }
    })
  }

  // 创建元素
  createModal = () => {
    const {type, timeType} = this.state
    const { getFieldDecorator } = this.props.form
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    }
    return (
      <Form onSubmit={this.handleSubmit} className="discount-form-create">
        <Form.Item label="优惠券名称：" className='flex'>
          {getFieldDecorator('name', {
            rules: [{
              required: true,
              message: '请输入优惠券名称',
            }],
          })(
            <Input placeholder="请输入优惠券名称" style={{width: 350}} />
          )}
        </Form.Item>
        <Form.Item label="优惠券类型：" className='flex'>
          {getFieldDecorator('type', { 
            rules: [{
              required: true,
              message: '请选择优惠券类型',
            }],
          })(
            <Radio.Group
              onChange={(e)=>{
                this.setState({type: e.target.value})
              }}
            >
              <Radio style={radioStyle} value={0}>满减券</Radio>
              <Radio style={radioStyle} value={1}>折扣券</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        {
          type === 1 
            ?<Form.Item label="折扣：" className='flex'>
              {getFieldDecorator('disCount', { 
                rules: [{
                  required: true,
                  message: '请输入消费折扣0~10',
                }],
              })(
                <span>
                  <InputNumber placeholder="消费折扣，0~10折" min={0.1} max={10} style={{width: 260, marginRight: 10}} />（0~10的数字）
                </span>
              )}
            </Form.Item>
            :<Form.Item label="面额：" className='flex'>
              {getFieldDecorator('amount', { 
                rules: [{
                  required: true,
                  message: '请输入优惠券面额',
                }],
              })(
                <InputNumber placeholder="优惠券面额" min={0.01} style={{width: 350}} />
              )}
            </Form.Item>
        }
        <Form.Item label="使用门槛：" className='flex'>
          {getFieldDecorator('useType', {
            rules: [{
              required: true,
              message: '请选择使用门槛类型',
            }],
          })(
            <Radio.Group
              onChange={(e) => {
                this.setState({
                  useType: e.target.value,
                })
              }}
            >
              <Radio style={radioStyle} value={0}>无限制</Radio>
              <Radio style={radioStyle} value={1}>消费满<InputNumber onChange={(e) => { this.setState({ useTypeVal: e }) }} style={{ width: 100, marginLeft: 10, marginRight: 10 }} min={0} /> 元可用</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Form.Item label="总发行量：" className='flex'>
          {getFieldDecorator('total', { 
            rules: [{
              required: true,
              message: '请输入总发行量',
            }],
          })(
            <InputNumber placeholder="请输入总发行量" style={{width: 350}} />
          )}
        </Form.Item>
        <Form.Item label="每人限领：" className='flex'>
          {getFieldDecorator('limit', { 
            rules: [{
              required: true,
              message: '请输入每人限制领取次数',
            }],
          })(
            <InputNumber placeholder="每人限制领取次数" style={{width: 350}} />
          )}
        </Form.Item>
        <Form.Item label="有效期：" className='flex'>
          {getFieldDecorator('timeType', {
            rules: [{
              required: true,
              message: '请选择有效日期类型',
            }],
          })(
            <Radio.Group
              onChange={(e) => {
                this.setState({
                  timeType: e.target.value,
                })
              }}
            >
              <Radio style={radioStyle} value={0}>固定天数{timeType === 0 ? <span>，用户领取 <InputNumber onChange={(e) => { this.setState({ days: e }) }} style={{ width: 100, marginLeft: 10, marginRight: 10 }} min={0} /> 天后到期</span> : null}</Radio>
              <Radio style={radioStyle} value={1}>日期范围{timeType === 1 ? <RangePicker style={{ width: 260, marginLeft: 10 }} onChange={(e)=>{ console.log(e); this.setState({timerArr: e}) }} /> : null}</Radio>
            </Radio.Group>
          )}
        </Form.Item>
        <Form.Item label="备注：" className='flex'>
          {getFieldDecorator('desc', { 
                 
          })(
            <TextArea placeholder="请输入备注" style={{width: 350, height: 80}} />
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={this.state.submitting} disabled={this.state.submitting} style={{width: 180, marginLeft: 90}}>保存</Button>
        </Form.Item>
      </Form>
    )
  }

  // 查看元素 
  lookModal (info) {
    return (
      <Form className="look-detail-inner" style={{ padding: 20, textAlign: 'right' }}>
        <Form.Item label="优惠券名称：" className='flex'>
          <Input value={info.name} readOnly style={{width: 350}} />
        </Form.Item>
        <Form.Item label="优惠券类型：" className='flex'>
          <Input value={info.type === 0 ? '满减券' : '折扣券'} readOnly style={{width: 350}} />
        </Form.Item>
        <Form.Item label="面额：" className='flex'>
          <Input value={info.type === 0 ? (info.disCount / 100).toFixed(2) + '元' : info.disCount*10 + '折'} readOnly style={{width: 350}} />
        </Form.Item>
        <Form.Item label="使用门槛：" className='flex'>
          <Input value={info.useType === 0 ? '无门槛' : '满' + (info.useTypeVal / 100).toFixed(2) + '可使用'} readOnly style={{width: 350}} />
        </Form.Item>
        <Form.Item label="有效期：" className='flex'>
          <Input value={info.timeType === 0 ? '领取后' + info.days + '天有效' : info.startAt + ' 至 ' + info.endAt} readOnly style={{width: 350}} />
        </Form.Item>
        <Form.Item label="总发行量：" className='flex'>
          <Input value={info.total} readOnly style={{width: 350}} />
        </Form.Item>
        <Form.Item label="每人限领：" className='flex'>
          <Input value={info.limit || 1} readOnly style={{width: 350}} />
        </Form.Item>
        <Form.Item label="备注：" className='flex'>
          <TextArea value={info.desc} readOnly style={{width: 350}} />
        </Form.Item>
      </Form>
    )
  }

  // 查看优惠券详情
  lookDetail = (id) => {
    discountDetail({id})
      .then(res => {
        let data = res.data.platformVal
        if (data && data.length) {
          data = JSON.parse(data)
          this.setState({ 
            info: res.data,
            lookModelVisible: true,
          })
        } else {
          this.setState({ 
            info: res.data,
            lookModelVisible: true,
          })
        }
      })
  }

  render () {
    const {
      isLoading, 
      list, 
      columns, 
      pageData, 
      lookModelVisible, 
      createModelVisible,
      info,
    } = this.state
    return (
      <Layout className="discount-page">
        { this.state.isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <div className='filter-inner'>
          <Row>
            <Col {...ColProps} xl={{ span: 4}} style={{width: 220}} className="flex-h-a">
              <Button className='creat-station' type="primary" icon="plus" style={{ marginBottom: 20, width: 160 }} onClick={this.create}>添加优惠券</Button>
            </Col>
            <Col {...ColProps} xl={{ span: 10}} md={{ span: 8 }} className="flex-h-a">
              <span >优惠券名称：</span>
              <Search style={{ width: 250 }} placeholder="优惠券名称搜索" onSearch={this.onSearch} enterButton />
            </Col>
          </Row>
          {
            !isLoading && (
              <Table 
                columns={columns} 
                dataSource={list} 
                bordered 
                rowKey="id" 
                pagination={{
                  current: pageData.current,
                  total: pageData.total, 
                  pageSize: pageData.pageSize,
                }} 
                onChange={this.onPageChange}
              />
            )
          }
          <Modal 
            title="创建优惠券"
            visible={createModelVisible} 
            onCancel={this.handleCancel} 
            width={600} 
            footer={false} 
          >
            {this.createModal()}
          </Modal>
          <Modal 
            title="查看优惠券"
            visible={lookModelVisible}
            onCancel={this.handleCancel} 
            width={600} 
            footer={false} 
          >
            {info && this.lookModal(info)}
          </Modal>
        </div>
      </Layout>
    )
  }
}

export default connect()(Form.create({ name: '' })(Discount))